<template>
    <div>
        <modal class="cropper" :display="modalStatus.bizCropper" @modalStatus="closeModal" >
            <div class="cropper-wrap">
                <div class="control-btn-group h-align">
                    <div class="turn-btn h-align" @click="rotateLeft">
                        <img src="@/assets/img/icon/turn_left.svg" alt="">
                        向左旋轉
                    </div>
                    <div class="turn-btn h-align" @click="rotateRight">
                        <img src="@/assets/img/icon/turn_right.svg" alt="">
                        向右旋轉
                    </div>
                </div>
                <div class="content">
                    <vue-cropper
                        ref="cropper"
                        :img="imgUrl"
                        :high="300"
                        :original="false"
                        :autoCrop="true"
                        :rotate="rotate"
                    />
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="getCropData()">確定</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import { VueCropper }  from 'vue-cropper';
import { mapGetters } from 'vuex';

export default {
    data () {
        return {
            cropImg: '',
            rotate: 0,
            data: null,
        }
    },
    props: {
        image: null,
        imageType: null
    },
    destroyed(){
    },
    watch: {
    },
    methods: {
        getCropData() {
            this.$refs.cropper.getCropData(data => {
                this.$emit('input', data)
                this.closeModal()
            })
        },
        // 向左边旋转
        rotateLeft() {
            this.$refs.cropper.rotateLeft()
        },
        // 向右边旋转
        rotateRight() {
            this.$refs.cropper.rotateRight()
        },
        closeModal: function () {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizCropper'})
        },
    },
    computed: {
        imgUrl: function () {
            if(this.imageType === 'FILE'){
                return this.image
            }else{
                return 'data:image/png;base64,'+this.image
            }
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        VueCropper
    }
}
</script>
<style lang="scss">
    #modal.cropper{
        .error{
            right: 0px;
            top: -24px;
            left: unset;
        }
        .modal-content{
            width: 664px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 42px;
                }
                .cropper-wrap{
                    width: 600px;
                    padding: 0 32px 0 32px;
                    .control-btn-group{
                        width: 200px;
                        margin: 0 auto;
                        padding: 24px 0 20px 0;
                        justify-content: space-between;
                        .turn-btn{
                            cursor: pointer;
                        }
                    }
                    .content{
                        margin-bottom: 40px;
                        height: 400px;
                        .equips-input{
                            margin-bottom: 24px;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 384px;
                    height: 44px;
                }
            }
        }
    }
    #modal.no-close{
        .cancle{
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/cropper.vue